import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-analytic-layout',
  templateUrl: './analytic-layout.component.html',
  styleUrls: ['./analytic-layout.component.less']
})
export class AnalyticLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}

